import React from "react";
import PropTypes from "prop-types";
import Close from "./Close";

const CloseList = ({ closeList, removeGrade }) => {

    return (
      <div className="close-list">
        <h3>Delete</h3>
        {closeList.map((close, index) => (
          <Close removeGrade = {removeGrade} key={index} />
        ))}
      </div>
    );
  
};

CloseList.propTypes = {};

export default CloseList;
